import { createSelector } from 'reselect';

const getLoginContextByKey = key => state => state.login[key];
const getFetchingContextByKey = key => state => state.login.fetching[key];
const getSignInApiContextByKey = key => state => state.login.signIn.api[key];
const getAuthContextByKey = key => state => state.login.auth[key];
const getAuthBusinessContextByKey = key => state =>
  state.login.auth.business[key];
const getAuthMvfContextByKey = key => state =>
  (state.login.auth.mvfContext || {})[key];
const getRegisterContextByKey = key => state => state.login.register[key];

export default {
  getAuth: getLoginContextByKey('auth'),
  getSignIn: getLoginContextByKey('signIn'),
  getState: getRegisterContextByKey('estado'),
  getCity: getRegisterContextByKey('city'),
  getMessageError: getRegisterContextByKey('error'),
  getStep: getRegisterContextByKey('step'),
  getAuthToken: getAuthContextByKey('token'),
  getPermissions: getAuthContextByKey('permissions'),
  getCountryCode: getAuthContextByKey('countryCode'),

  getAuthUserId: createSelector(
    getAuthContextByKey('userId'),
    state => state
  ),
  getAuthCompanyId: createSelector(
    getAuthBusinessContextByKey('accountId'),
    getAuthMvfContextByKey('usecoreAccountId'),
    getAuthBusinessContextByKey('id'),
    (accountId, mvfAccountId, id) => Number(accountId) > 0 ? accountId : (Number(mvfAccountId) > 0 ? mvfAccountId : id)
  ),
  getAuthUserName: createSelector(
    getAuthContextByKey('name'),
    state => state
  ),
  getHasLoadedPermissions: createSelector(
    getAuthContextByKey('hasLoadedPermissions'),
    state => state
  ),
  getUserHasAccount: createSelector(
    getAuthContextByKey('userHasAccount'),
    state => state
  ),
  getToken: createSelector(
    getSignInApiContextByKey('signIn'),
    state => state.token
  ),
  getFetchingCreateAccount: createSelector(
    getRegisterContextByKey('fetching'),
    state => state.createAccount
  ),
  getFetchingCreateAccountError: createSelector(
    getRegisterContextByKey('fetching'),
    state => state.createAccountError
  ),
  getIsShowVerifyEmail: createSelector(
    getRegisterContextByKey('showVerifyEmail'),
    state => state
  ),
  getFetchingResendEmail: createSelector(
    getRegisterContextByKey('fetching'),
    state => state.resendEmail
  ),
  getIsRecoverSuccessful: createSelector(
    getFetchingContextByKey('recoverSuccessful'),
    state => state
  ),
  getIsTokenInvalid: createSelector(
    getFetchingContextByKey('isRecoverTokenInvalid'),
    state => state
  ),
  getAuthBusinessWorkspaceId: createSelector(
    getAuthBusinessContextByKey('workspaceId'),
    state => state
  ),
  getAuthBusinessAccountId: createSelector(
    getAuthBusinessContextByKey('accountId'),
    state => state
  ),
  getAuthBusinessAccountProfileId: createSelector(
    getAuthBusinessContextByKey('accountProfileId'),
    state => state
  ),
  getHeaderConfigAccount: createSelector(
    getAuthContextByKey('token'),
    getAuthBusinessContextByKey('accountId'),
    getAuthMvfContextByKey('usecoreAccountId'),
    getAuthBusinessContextByKey('id'),
    (token, accountId, mvfAccountId, id) => ({ token, accountId: Number(accountId) > 0 ? accountId : (Number(mvfAccountId) > 0 ? mvfAccountId : id) })
  ),
  getHeaderConfig: createSelector(
    getAuthContextByKey('token'),
    getAuthContextByKey('lang'),
    getAuthBusinessContextByKey('accountId'),
    getAuthMvfContextByKey('usecoreAccountId'),
    getAuthBusinessContextByKey('id'),
    getAuthBusinessContextByKey('workspaceId'),
    (token, lang, accountId, mvfAccountId, id, workspaceId) => ({ token, lang, accountId: Number(accountId) > 0 ? accountId : (Number(mvfAccountId) > 0 ? mvfAccountId : id), workspaceId })
  ),
  getAuthGroupPermission: createSelector(
    getAuthContextByKey('groupPermission'),
    state => state
  ),
  getFileReferenceWorkspace: createSelector(
    getAuthBusinessContextByKey('avatarFileReference'),
    state => state
  ),
  getAuthBusinessAccountName: createSelector(
    getAuthBusinessContextByKey('name'),
    state => state
  ),
};
